const red100Color = '#F5D6D6';

export default red100Color;
